<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useSession } from '@/auth/session';
import { errorMessage } from '@/utils/format';

const route = useRoute();
const router = useRouter();
const session = useSession();
const username = ref('');
const password = ref('');
const submitting = ref(false);
const error = ref('');
const redirectPath = computed(() => {
  const value = typeof route.query.redirect === 'string' ? route.query.redirect : '/';
  return value.startsWith('/') ? value : '/';
});

async function submit(): Promise<void> {
  if (!username.value.trim() || !password.value) {
    error.value = '请输入用户名和密码。';
    return;
  }
  submitting.value = true;
  error.value = '';
  try {
    await session.login(username.value.trim(), password.value);
    await router.replace(redirectPath.value);
  } catch (caught) {
    password.value = '';
    error.value = errorMessage(caught);
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <main class="login-page">
    <section class="login-panel" aria-labelledby="login-title">
      <div class="login-brand">
        <strong>PDM<span>·</span>系统</strong>
        <small>东禾智能 · 产品与项目数据管理</small>
      </div>
      <header>
        <span>SIGN IN</span>
        <h1 id="login-title">登录 PDM 系统</h1>
        <p>用户名是你的工号，密码沿用原 EQS 的密码。忘记密码找管理员重置。</p>
      </header>
      <form @submit.prevent="submit">
        <label>
          <span>用户名</span>
          <input v-model="username" name="username" autocomplete="username" autofocus />
        </label>
        <label>
          <span>密码</span>
          <input
            v-model="password"
            name="password"
            type="password"
            autocomplete="current-password"
          />
        </label>
        <p v-if="error" class="login-error" role="alert">{{ error }}</p>
        <button class="button button-primary" type="submit" :disabled="submitting">
          {{ submitting ? '正在登录…' : '登录' }}
        </button>
      </form>
      <footer>内部系统 · 请勿向他人透露账号信息</footer>
    </section>
  </main>
</template>
